<template>
  <Slideover :visible="visible">
    <div>
      <form v-on:submit.prevent="updateOrderCustomerInfo">
        <!-- Header -->
        <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
          <div class="flex items-start justify-between space-x-3">
            <h2 class="text-lg leading-7 font-medium">
              {{ title }}
            </h2>
            <div class="h-7 flex items-center">
              <button
                type="button"
                aria-label="Close panel"
                @click="
                  hasRestrictedItems ? $router.go(0) : $emit('toggle-slideover')
                "
                class="text-green-300 hover:text-white transition ease-in-out duration-150"
              >
                <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
              </button>
            </div>
          </div>
        </header>

        <!-- Body -->
        <div>
          <h2 class="text-lg leading-7 font-medium ml-4 mt-2">Shipping</h2>
          <div
            class="relative flex-1 py-3 px-2 mx-4 bg-white border border-gray-200 rounded-lg"
          >
            <div class="grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label
                  for="ShipName"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Name
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipName"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipName"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="ShipCompany"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Company
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipCompany"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipCompany"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="Email"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Email address
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="Email"
                    type="email"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.Email"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="phone"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Phone
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="phone"
                    type="phone"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipPhone"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="ShipAddress"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Address
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipAddress"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipAddress"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-3">
                <label
                  for="ShipAddress2"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Address 2
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipAddress2"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipAddress2"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="ShipCity"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  City
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipCity"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipCity"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="ShipState"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  State / Province
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <select
                    v-if="!testingSelectedState"
                    id="ShipState"
                    v-model="order.ShipState"
                    @change="onStateChange()"
                    :disabled="showComplete || testingSelectedState"
                    :class="{ 'opacity-50': showComplete }"
                    class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  >
                    <option v-for="state in states" :key="state.index">
                      {{ state }}
                    </option>
                  </select>
                  <LoadingSpinner v-if="testingSelectedState" class="text-green-500 mt-2" />
                </div>
              </div>

              <div class="sm:col-span-2">
                <label
                  for="ShipZip"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  ZIP / Postal
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="ShipZip"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="order.ShipZip"
                    :disabled="showComplete"
                    :class="{ 'opacity-50': showComplete }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <HttpError :error="error" />

        <!-- State restriction errors. -->
        <div v-if="hasRestrictedItems" class="py-2 px-4 text-base">
          <div class="relative rounded-md bg-red-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <icon
                  set="solid"
                  name="x-circle"
                  class="h-5 w-5 text-red-400"
                />
              </div>
              <div class="ml-3 space-y-2">
                <h3 class="text-sm leading-5 font-medium text-red-800">
                  <div class="whitespace-pre">
                    The following variants are restricted in
                    {{ currentSelectedShipState }}:
                  </div>
                  <div class="whitespace-pre-line">
                    {{ restrictedItems.join() }}
                  </div>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isPoBox" class="py-2 px-4 text-base">
          <div class="relative rounded-md bg-red-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <icon
                  set="solid"
                  name="x-circle"
                  class="h-5 w-5 text-red-400"
                />
              </div>
              <div class="ml-3 space-y-2">
                <h3 class="text-sm leading-5 font-medium text-red-800">
                  <div class="whitespace-pre">Cannot ship to a PO Box</div>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <bad-address-validation-status
          class="py-2 px-4 text-base"
          v-if="validatedAddress"
          :validated-address="validatedAddress"
        />
        <!-- Footer -->
        <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
          <span class="inline-flex rounded-md shadow-sm">
            <button
              type="button"
              @click="
                hasRestrictedItems ? $router.go(0) : $emit('toggle-slideover')
              "
              class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
            >
              Cancel
            </button>
          </span>
          <span class="inline-flex rounded-md shadow-sm">
            <button
              v-if="!showComplete"
              :disabled="
                saving ||
                hasRestrictedItems ||
                checkingStateRestrictions ||
                isPoBox
              "
              type="submit"
              :class="{
                'cursor-wait': saving,
                'opacity-50':
                  saving ||
                  checkingStateRestrictions ||
                  hasRestrictedItems ||
                  isPoBox,
              }"
              class="inline-flex justify-center items-center space-x-2 py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out disabled:cursor-not-allowed"
            >
              <span>Save</span>
              <LoadingSpinner v-if="saving" class="text-white" />
            </button>
            <button
              v-if="showComplete"
              @click.prevent="complete"
              type="button"
              class="inline-flex justify-center items-center space-x-2 py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out disabled:cursor-not-allowed"
            >
              <span>Complete</span>
            </button>
          </span>
        </div>
      </form>
    </div>
  </Slideover>
</template>
<script>
import Slideover from "@/components/layout/Slideover.vue";
import states from "@/data/statesAbbrev.json";

import { ApiFactory } from "@/api/ApiFactory.js";
import BadAddressValidationStatus from "@/views/Reports/components/BadAddressValidationStatus";
const UtilitiesApi = ApiFactory.get("utilities");

export default {
  name: "OrderCustomerEdit",
  data() {
    return {
      saving: false,
      checkingStateRestrictions: false,
      error: null,
      states: states,
      hasRestrictedItems: false,
      restrictedItems: [],
      currentSelectedShipState: null,
      showComplete: false,
      validatedAddress: null,
      testingSelectedState: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    footer: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
    },
    badAddress: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.currentSelectedShipState = this.order.ShipState;
    this.getCurrentRestrictedItems();
  },
  components: {
    BadAddressValidationStatus,
    Slideover,
  },
  computed: {
    isPoBox() {
      const poBoxReg = /\b[Pp]([.]*([Oo]|0))?([.]*[Bb]ox)?([.]*[Dd]rawer)?\b/;
      if (
        poBoxReg.test(this.order.ShipAddress) ||
        poBoxReg.test(this.order.ShipAddress2)
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    complete() {
      this.$emit("complete");
      this.$emit("toggle-slideover");
    },
    getCurrentRestrictedItems() {
      this.checkingStateRestrictions = true;
      this.hasRestrictedItems = false;
      this.restrictedItems = [];
      const payload = {
        shipState: this.currentSelectedShipState,
        criteria: []
      };
      const variantsByFacility = new Map();
      const dropshipVariants = [];
      this.order.details.forEach(detail => {
        if (detail.Canceled == "1") {
          return;
        }
        if (detail.DropShip == "1") {
          dropshipVariants.push(detail.variant_id);
        }
        else {
          if (!variantsByFacility.has(detail.facility_id)) {
            variantsByFacility.set(detail.facility_id, []);
          }
          variantsByFacility.get(detail.facility_id).push(detail.variant_id);
        }
       });
      variantsByFacility.forEach((value, key) => {
        payload.criteria.push({
          facilityId: key,
          variantIds: value
        });
      });
      if (dropshipVariants.length > 0) {
        payload.criteria.push({
          dropship: true,
          variantIds: dropshipVariants
        });
      }
      if (payload.criteria.length == 0) {
        this.hasRestrictedItems = false;
        this.checkingStateRestrictions = false;
        return;
      }
      UtilitiesApi.testStateRestrictions(payload)
        .then((response) => {
          const res = response.data.body;
          if (res.restricted) {
            res.restrictedItems.forEach((item) => {
              this.restrictedItems.push(item.variantId);
            });
          }
          this.hasRestrictedItems = this.restrictedItems.length > 0;
          this.checkingStateRestrictions = false;
          this.testingSelectedState = false;
        })
        .catch((e) => (this.error = e));
    },
    onStateChange() {
      this.testingSelectedState = true;
      this.currentSelectedShipState = this.order.ShipState;
      this.getCurrentRestrictedItems();
    },
    updateOrderCustomerInfo() {
      this.saving = true;
      this.error = null;
      this.showComplete = false;

      const fields = [
        "Email",
        "ShipName",
        "ShipCompany",
        "ShipEmail",
        "ShipAddress",
        "ShipAddress2",
        "ShipCity",
        "ShipState",
        "ShipZip",
        "ShipPhone",
      ];

      let data = Object.keys(this.order).reduce((object, key) => {
        if (fields.includes(key)) object[key] = this.order[key];
        return object;
      }, {});
      data.ShippingUpdate = true;

      this.$store
        .dispatch("orders/updateOrder", {
          OrderNumber: this.order.SourceOrderNumber,
          data: data,
        })
        .then(() => {
          if (!this.badAddress) {
            this.$emit("toggle-slideover");
          } else {
            let order = this.$store.getters["orders/getOrder"];
            this.validatedAddress = order.validateAddress;
            this.showComplete = true;
          }
        })
        .catch((e) => (this.error = e))
        .finally(() => {
          this.saving = false;
          if (!this.badAddress) {
            this.$router.go(0);
          }
        });
    },
  },
  mounted() {},
  filters: {},
};
</script>
